
import { Action } from 'vuex-class';
import { Vue, Component, Watch } from "vue-property-decorator";
import LayoutLoading from "@/components/shared/layout/FblLayoutLoading.vue";
import InfoModal from "@/plugins/notification/infoModal";
import DefaultModal from "@/components/modal/DefaultModal.vue";
import { InsuredInformationVO, CreditInformationOutput, InsureInformationOutput, CreditValidateInput, CreditValidateOutput, InsuredValidateInput, InsuredValidateOutput } from "@fubonlife/tacallindiy-core-axios-sdk";
import InsuredDetailModal from "@/pages/Insure/modals/InsuredDetailModal.vue"
import AnotherCompanyInsure from "@/pages/Insure/modals/AnotherCompanyInsure.vue"
import UpdateCreditCard from "@/pages/Insure/modals/UpdateCreditCard.vue"
interface CompanySelected {
	key: string,
	companyID: string,
	companyName: string,
	amount: string
}

interface ParamFromInsureStep3 {
	proposalData: InsuredInformationVO[],
	insuredInformations: InsuredInformationVO[],
	allCheck: boolean
}

@Component({ components: { LayoutLoading, DefaultModal, InsuredDetailModal, AnotherCompanyInsure, UpdateCreditCard } })
export default class Insure_step4 extends Vue {

	@Action('setLoading') setLoading;
	screenWidth: number = 0;
	modalWidth = '90%'
	me = null;
	updateCreditSubmitDisabled:boolean = false;

	form = {
		day: '',
		startTime: '',
		endTime: '',
		travelArea: [],
		totalFee: 0,
		hasAnotherCompany: false,
		guardianDeclar: false,
		bank: '',
		creditCard: '',
	}

	creditInfo = {
		originCardNum: '',
		errorMsg: '',
		idNo: '',
		expiryDate: ''
	}

	insuredInformations: InsuredInformationVO[] = []

	modal = {
		insuredModal: {
			title: '保費明細',
			isOpenDetail: false,
		},
		companyModal: {
			title: '保費清單',
			isOpenDetail: false,
		},
		creditCardModal: {
			title: '信用卡資訊',
			isOpenDetail: false,
		}
	}

	companyList: CompanySelected[] = [];

	isFirstTimeFetch: boolean = true;

	get getCompanyCount() {
		return this.companyList.length;
	}

	get getCompanyTotalAmount() {
		return this.companyList.map(e => parseInt(e.amount)).reduce((a, b) => a + b);
	}

	async created() {
		this.me = this.$user.getMe();
		const $params = this.$global.getParam();
		if (!$params || !this.me) {
			// 轉逾時頁面
			this.setLoading(false);
			this.$router.replace({ path: '/application-timeout' })
			return;
		}
		try {
			this.setLoading(true);
			const $query: ParamFromInsureStep3 = $params.query;
			if (!$query) {
				this.setLoading(false);
				InfoModal.alertModal({
					alertType: "error",
					title: "錯誤",
					content: "無法取得投保資訊，請重新嘗試。",
					customContent: null,
				});
			}
			const $infos = $query.insuredInformations;
			console.log('insuredInformations', $infos);
			this.insuredInformations = $infos;
			this.form.totalFee = $infos.reduce((acc, obj) => acc + parseInt(obj.fee), 0);
			// 取得投保資訊
			await this.fetchInsureInfo();
			// 取得信用卡資訊
			await this.fetchCreditCardInfo()
			this.getCacheData();
		} finally {
			this.setLoading(false);
		}
	}

	// 取得畫面寬度
	mounted() {
		this.screenWidth = document.body.clientWidth;
		window.addEventListener('resize', () => {
			return (() => {
				this.screenWidth = document.body.clientWidth;
			})();
		})
	}

	@Watch('screenWidth')
	modalWidthChange() {
		if (this.screenWidth <= 500) {
			this.modalWidth = '90%';
		} else if (500 < this.screenWidth && this.screenWidth <= 1024) {
			this.modalWidth = '70%';
		} else {
			this.modalWidth = '50%';
		}
	}

	// 取得緩存
	getCacheData() {
		const $params = this.$cache.getParam();
		if ($params) {
			this.form.hasAnotherCompany = $params.hasAnotherCompany;
			this.companyList = $params.companyList;
			if ($params.hasAnotherCompany) {
				this.isFirstTimeFetch = false;
			} else {
				this.isFirstTimeFetch = true;
			}
		}
	}

	async fetchInsureInfo() {
		const token = this.me.token;
		await this.$InformationControllerApi.getInsureInformationUsingPOST1(token)
			.then(res => {
				if (res.status === 200) {
					const result: InsureInformationOutput = JSON.parse(JSON.stringify(res.data))
					if (result.processStatus.status === 'SUCCESS') {
						this.form.day = result.travelDays;
						this.form.startTime = result.startDateTime;
						this.form.endTime = result.endDateTime;
						this.form.travelArea = result.travelAreas;
						this.creditInfo.idNo = result.idNo;
					} else {
						InfoModal.alertModal({
							alertType: "error",
							title: "錯誤",
							content: result.processStatus.message,
							customContent: null,
						});
					}
				} else {
					InfoModal.alertModal({
						alertType: "error",
						title: "錯誤",
						content: "投保資訊取得失敗，請重新嘗試。",
						customContent: null,
					});
				}
			})
	}

	async fetchCreditCardInfo() {
		const callInNumber = this.me.callInNumber;
		await this.$InformationControllerApi.getCreditInformationUsingPOST1(callInNumber)
			.then(res => {
				if (res.status === 200) {
					const result: CreditInformationOutput = JSON.parse(JSON.stringify(res.data))
					if (result.processStatus.status === 'SUCCESS') {
						this.form.bank = result.bank;
						this.form.creditCard = result.cardNumber;

					} else {
						InfoModal.alertModal({
							alertType: "error",
							title: "錯誤",
							content: result.processStatus.message,
							customContent: null,
						});
					}
				} else {
					InfoModal.alertModal({
						alertType: "error",
						title: "錯誤",
						content: "信用卡資訊取得失敗，請重新嘗試。",
						customContent: null,
					});
				}
			})
	}

	@Watch('form.hasAnotherCompany')
	hasAnotherCompany() {
		if (!this.isFirstTimeFetch) {
			this.isFirstTimeFetch = true;
			return;
		}
		if (this.form.hasAnotherCompany) {
			this.openModal('companyModal')
		}
	}


	openModal(modalName: string) {
		this.modal[modalName].isOpenDetail = true;
	}

	guardianDeclarOpen() {
		InfoModal.alertModal({
			alertType: "info",
			title: "何謂受監護宣告？",
			content: `對於精神障礙或其他心智缺陷，致不能為意思表示或受意思表示，或不能辨識其意思表示效果者，法院得依聲請人之聲請，為監護之宣告。`,
		})
	}

	guardianDeclarChange() {
		if (this.form.guardianDeclar) {
			InfoModal.alertModal({
				alertType: "warning",
				title: "提醒",
				content: `目前受有監護宣告之被保險人請改以書面方式投保，並檢附手冊或證明！`,
			})
			this.form.guardianDeclar = false;
		}
	}

	companyListChange($evet: CompanySelected[]) {
		this.companyList = $evet;
	}

	closeCompanyModal() {
		if (this.getCompanyCount === 0) {
			this.form.hasAnotherCompany = false;
		}
		this.modal.companyModal.isOpenDetail = false;
	}

	async handleNextStep() {
		// 檢核信用卡
		let isPassCredit = await this.creditVadite();
		this.modal.creditCardModal.isOpenDetail = !isPassCredit;
		if (!isPassCredit) return;
		// 取授權 & 確定投保
		await this.insuredValidate();
	}

	// 確定投保
	async insuredValidate() {
		const me = this.me;
		let insuredOtherCompanyInformation = [];
		if (this.form.hasAnotherCompany) {
			insuredOtherCompanyInformation = this.companyList.map(e => {
				return {
					companyID: e.companyID,
					companyName: e.companyName,
					insuredFee: e.amount
				}
			})
		}
		const input: InsuredValidateInput = {
			callInNumber: me.callInNumber,
			insuredInformations: this.insuredInformations,
			insuredOtherCompanyInformation: insuredOtherCompanyInformation,
			insuredOtherCompanyStatus: this.form.hasAnotherCompany,
			totalFee: this.form.totalFee.toString()
		}
		console.log('start valid insured...');
		this.setLoading(true)
		this.$ValidateControllerApi.insuredValidateUsingPOST1(me.token, input)
			.then(res => {
				if (res.status === 200) {
					const result: InsuredValidateOutput = JSON.parse(JSON.stringify(res.data))
					if (result.processStatus.status === 'SUCCESS' && result.processStatus.statusCode === '01005001') {
						// 預約投保成功
						this.$router.replace({ name: "ApplicationCompleted" });
					} else if (result.processStatus.statusCode === '03010002') {
						// 確定投保完成，但TOKEN已有對應保單號碼
						this.$router.replace({ name: "ApplicationFailed" });
					} else if (result.processStatus.statusCode === '01005002') {
						// 取授失敗
						this.creditInfo.errorMsg = result.processStatus.message;
						this.modal.creditCardModal.isOpenDetail = true;
					} else if (result.processStatus.statusCode === '01005003') {
						InfoModal.alertModal({
							alertType: "error",
							title: "錯誤",
							content: "無法取得商店及端末機代號，請重新嘗試。",
							customContent: null,
						});
					} else {
						this.$router.replace({ name: "ApplicationFailed" });
					}
				}
				else {
					InfoModal.alertModal({
						alertType: "error",
						title: "錯誤",
						content: "申請失敗，請重新嘗試。",
						customContent: null,
					});
				}
			})
			.finally(() => {
				console.log('end valid insured...');
				this.setLoading(false)
			})
	}

	// 信用卡檢核
	async creditVadite() {
		const me = this.me;
		const creditInfo: CreditValidateInput = {
			callInNumber: this.me.callInNumber,
			cardNumber:this.creditInfo.originCardNum,
			expiryDate:this.creditInfo.expiryDate,
			idNo:this.creditInfo.idNo
		}
		console.log('creditInfo',creditInfo)
		this.setLoading(true)
		this.updateCreditSubmitDisabled = true;
		let isPassCredit = false;
		console.log('start valid creditcard...' + new Date());
		await this.$ValidateControllerApi.creditValidateUsingPOST1(me.token, creditInfo)
			.then(res => {
				console.log('get valid creditcard result...' + new Date());
				if (res.status === 200) {
					const result: CreditValidateOutput = JSON.parse(JSON.stringify(res.data))
					if (result.processStatus.status === 'SUCCESS') {
						this.creditInfo.originCardNum = result.cardNumber;
						this.creditInfo.expiryDate = result.expiryDate;
						if (result.status) {
							// 取授成功
							this.form.creditCard = result.cardNumber;
							this.form.bank = result.bank;
							isPassCredit = true;
						} else {
							this.creditInfo.errorMsg = result.errorMsg;
							this.modal.creditCardModal.isOpenDetail = true;
						}
					} else {
						this.creditInfo.errorMsg = result.processStatus.message;
						this.modal.creditCardModal.isOpenDetail = true;
					}
				} else {
					InfoModal.alertModal({
						alertType: "error",
						title: "錯誤",
						content: "信用卡無法取得授權，請重新嘗試。",
						customContent: null,
					});
				}
			})
			.finally(() => {
				console.log('end valid creditcard result...' + new Date());
				this.setLoading(false)
				this.updateCreditSubmitDisabled = false;
			})
		return isPassCredit;
	}

	// 回上一步
	handlePreviousStep() {
		const $object = {
			hasAnotherCompany: this.form.hasAnotherCompany,
			companyList: this.companyList
		}
		this.$cache.setParam($object)
		this.$router.push({ name: 'InsureStep3' });
	}

	// 修改信用卡 - 取消
	handleCancelUpdateCredit() {
		this.modal.creditCardModal.isOpenDetail = false;
	}

	// 修改信用卡 - 完成
	async handleAfterUpdateCredit($event) {
		this.creditInfo.originCardNum = $event.cardNumber
		this.creditInfo.expiryDate = $event.effectiveDate
		await this.handleNextStep();
	}
}
